const imgWidth = $('.fr-fic').width();
const imgHeight = $('.fr-fic').height();
const background = $('.img-background-left, .img-background-right')

background.css("height", imgHeight + 50).css("width", imgWidth)
